import styled from 'styled-components';
import {
  companyColor,
  font,
  defaultColor,
  fluidFont,
  device,
} from 'styles/theme';

export const TableWrapper = styled.div`
  width: 100%;
  overflow-x: auto;
  overflow-y: hidden;
  -webkit-overflow-scrolling: touch;
`;

export const Table = styled.table`
  border: 1px solid ${defaultColor('background')};
  border-radius: 12px;
  width: 100%;
  min-width: 560px;
  border-spacing: 0px;
  overflow: hidden;
  ${({ $fixed }) => $fixed && 'table-layout: fixed;'}

  @media only screen and (${device('tablet')}) {
    min-width: 520px;
  }

  @media only screen and (${device('mobileSmall')}) {
    min-width: 460px;
  }

  @media only screen and (${device('laptop')}) {
    min-width: 100%;
  }
`;

export const TableHeader = styled.th`
  text-align: ${({ $align }) => $align || 'right'};
  white-space: nowrap;

  &:first-child {
    text-align: ${({ $align }) => $align || 'left'};
    white-space: normal;
  }
  background-color: ${defaultColor('background')};
  font-family: ${font('semibold')};
  ${fluidFont('12px', '14px')}
  color: ${companyColor('font')};
  padding: 20px 30px;
  overflow: hidden;
  text-overflow: ellipsis;

  @media only screen and (${device('tablet')}) {
    padding: 0.875rem 1rem;
  }
`;

export const Cell = styled.td`
  text-align: right;
  vertical-align: top;

  &:first-child {
    text-align: left;
    white-space: normal;
    min-width: 180px;
  }

  padding: 15px 20px;
  border-bottom: 1px solid ${defaultColor('background')};
  color: ${({ isBold }) => (isBold ? companyColor('font') : defaultColor('font'))};
  font-family: ${({ isBold }) => (
    isBold ? font('semibold') : font('regular')
  )};
  ${fluidFont('11px', '13px')};
  white-space: nowrap;

  @media only screen and (${device('tablet')}) {
    padding: 0.875rem 1rem;
  }

  @media only screen and (${device('mobileSmall')}) {
    padding: 0.75rem 0.875rem;
  }
`;
